import { devUrl, domain } from 'config'
import { privateKeyToAccount } from 'viem/accounts'

import { store } from 'store/index'
import { getDeadline } from 'utils/deadline'

import { typings } from './typings'

type Arg = {
  payload?: unknown
  primaryType: keyof typeof typings
  url: string
}

export const getSignature = async ({ payload, primaryType, url: urlArg }: Arg) => {
  const deadline = getDeadline()

  const { appInfo, user } = store.getState()
  const { signAcountPrivateKey } = user
  const { chainId, ufarmCoreAddress } = appInfo.appData

  if (!signAcountPrivateKey) return { deadline, signature: null }

  const privateAccount = privateKeyToAccount(signAcountPrivateKey)

  const urlObj = new URL(`${devUrl}${urlArg}`)

  urlObj.search = ''
  urlObj.hash = ''
  const url = urlObj.toString()

  const message = {
    deadline,
    domain: url,
    payload: payload || {},
  }
  const types = {
    Payload: [
      { name: 'domain', type: 'string' },
      { name: 'deadline', type: 'uint256' },
      { name: 'payload', type: primaryType },
    ],
    [primaryType]: typings[primaryType],
  }

  const signature: string = await privateAccount.signTypedData({
    domain: { ...domain, chainId, verifyingContract: ufarmCoreAddress },
    message,
    primaryType: 'Payload',
    types,
  })

  return { deadline, signature }
}
